module.exports = __webpack_public_path__ + "static/media/twitter.3370a9c8.png";